import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/reducers';
import { Upload } from './state/upload-hook-reducer';

const useUpload = (): [Upload[]] => {
  const uploadState = useSelector((state: RootState) => state.upload.uploads);

  return [uploadState];
};

export default useUpload;
